import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import getters from "./getters";
import permission from "./modules/permission";
import user from "./modules/user";
// 计费规则 =>end
import dict from "./modules/dict";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    dict,
  },
  getters,
});

export default store;
